// /* eslint-disable no-unused-vars */
// import Plyr from 'plyr';

// window.addEventListener('load', () => {
// 	initPlyr()
// })

// const initPlyr = () => {
// 	const player = new Plyr('.player', {
// 		autoplay: true,
// 		loop: {
// 			active: true
// 		},
// 		youtube: {
// 			autoplay: true,
// 			modestbranding: false
// 		},
// 		vimeo: {
// 			autoplay: true
// 		},
// 		muted: true,
// 		hideControls: true
// 	});

// 	player.on('ready', () => {
// 		player.play()
// 	});

// 	player.on('ended', () => {
// 		player.restart();
// 	});
// }



// WEBPACK FOOTER //
// ./js/modules/content/media/video.js